import { Component } from '../../../../global/interfaces/component.interface';
import { MoleculeFormstepAddSystemComponentProps } from '../m-formstep-add-system-component/m-formstep-add-system-component.data';
import { MoleculeMainPartComponentProps } from '../m-formstep-main-part-component/m-formstep-main-part-component.data';
import { endpoint, endpointStub, FormStepProductsEndpoints } from './mocks/utils';


export type AppDataTypes = {
    endpoints: Record<FormStepProductsEndpoints, string>,
    translations: Record<string, string>
}
export interface MoleculeFormstepWarrantyWolfProductsProps {
    partName: string
    addSystemComponent: MoleculeFormstepAddSystemComponentProps
    appData: AppDataTypes
    mainPartComponent: MoleculeMainPartComponentProps
}

export const WARRANTY_WOLF_PRODUCT_APP_DATA_ID = 'warranty-wolf-app-data'

export const MyMoleculeFormstepWarrantyWolfProducts: Component<MoleculeFormstepWarrantyWolfProductsProps> = {
    data: {
        partName: 'Hauptgerät',
        addSystemComponent: {
            text: 'Systemkomponente hinzufügen',
            icon: 'plus-filled'
        },
        appData: {
            endpoints: {
                verifyMainComponent: endpointStub + endpoint.verifyMainComponent,
                verifySubComponent: endpointStub + endpoint.verifySubComponent,
            },
            translations: {
                serialNumber: 'Seriennummer (falls bekannt)',
                componentTitlePrefix: 'Systemkomponente',
                componentPart: 'Komponentenart',
                shortDescription: 'Kurzbeschreibung',
                deleteComponentButton: 'Delete',
                deleteComponentTitle: 'Delete Component',
                submitComponentTitle: 'Submit Component',
                submitComponentButton: 'Submit'
            }
        },
        mainPartComponent: {
            id: 'hauptgerät',
            mainPartName: 'Hauptgerät',
            translations: {
                serialNumber: 'Seriennummer (falls bekannt)',
                installationDate: 'Tag der Inbertriebhahme'
            },
            icon: 'close-outlined-circle'
        }
    }
}
